import { render, staticRenderFns } from "./Buildings.vue?vue&type=template&id=4c0c81a4&scoped=true&"
import script from "./Buildings.vue?vue&type=script&lang=ts&"
export * from "./Buildings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0c81a4",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c0c81a4')) {
      api.createRecord('4c0c81a4', component.options)
    } else {
      api.reload('4c0c81a4', component.options)
    }
    module.hot.accept("./Buildings.vue?vue&type=template&id=4c0c81a4&scoped=true&", function () {
      api.rerender('4c0c81a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/buildings/Buildings.vue"
export default component.exports